import Dog1 from './assets/dog1portrait.jpg';
import Guy from './assets/guyportrait.jpg';
import Camera from './assets/cameraportrait.jpg';
import Sofa from './assets/sofaportrait.jpg';
import Woman from './assets/womanportrait.jpg';
import TakingPic from './assets/takingpicportrait.jpg';
import Jungle from './assets/junglelandscape.jpg';
import Mountain from './assets/mountainlandscape.jpg';
import Sea from './assets/sealandscape.jpg';
import LivingRoom from './assets/livingroomland.jpg';
import Bridge from './assets/bridgelandscape.jpg';

export const pictureDB = [
    {
        id: 1,
        type: 'portrait',
        picture: Dog1
    },
    {
        id: 2,
        type: "portrait",
        picture: Guy
    },
    {
        id: 3,
        type: "portrait",
        picture: Camera
    },
    {
        id: 4,
        type: "portrait",
        picture: Sofa
    },
    {
        id: 5,
        type: "portrait",
        picture: Woman
    },
    {
        id: 6,
        type: "portrait",
        picture: TakingPic
    },
    {
        id: 7,
        type: "landscape",
        picture: Jungle
    },
    {
        id: 8,
        type: "landscape",
        picture: Mountain
    }, 
    {
        id: 9,
        type: 'landscape',
        picture: Sea
    },
    {
        id: 10,
        type: "landscape",
        picture: LivingRoom
    },
    {
        id: 11,
        type: 'landscape',
        picture: Bridge
    }
]